import { useInfiniteQuery } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { formatPodPackagesListResponse } from '../transformers';
import { IGetPodInventoryListPayload } from '../../../types';

/**
 * This is to track the Inbound details from the backend.
 */
const INBOUND_POD_INVENTORY_LIST_KEY = 'inbound-pod-inventory-list-query';

export const useInboundPodInventoriesListQuery = (
  payload: IGetPodInventoryListPayload
) => {
  const {
    filterKey,
    inventoryTransactionId,
    limit,
    podIdentifier,
    recordType,
    searchText,
    trayNumber,
    zone,
  } = payload;
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    queryKey: [
      INBOUND_POD_INVENTORY_LIST_KEY,
      filterKey,
      inventoryTransactionId,
      limit,
      podIdentifier,
      recordType,
      searchText,
      trayNumber,
      zone,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      INBOUND_API.getPodInventoryListInfo({ ...payload, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
    select: formatPodPackagesListResponse,
  });

  return {
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isPodInventoryFetchingError: isError,
    isPodInventoryLoading: isPending,
    // podInventoryData: formatPodPackagesListResponse(data),
    podInventoryData: data,
    podInventoryFetchError: error,
    refetchPodInventoryList: refetch,
  };
};
